
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.13 15.13"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_30612","data-name":"Path 30612","d":"M14.238 7.565A2.224 2.224 0 0011.575 4h-.005V2.226a2.224 2.224 0 00-4-1.333A2.224 2.224 0 104 3.556H2.225a2.224 2.224 0 00-1.333 4 2.224 2.224 0 102.666 3.56v1.781a2.224 2.224 0 004 1.333 2.224 2.224 0 003.562-2.664h1.78a2.224 2.224 0 001.333-4M12.9 4.45a1.335 1.335 0 010 2.67h-1.33V5.786A1.337 1.337 0 0112.9 4.45M9.345.891a1.337 1.337 0 011.335 1.335v3.56a1.336 1.336 0 01-1.335 1.335H8.01v-4.9A1.337 1.337 0 019.345.891M4.45 2.226a1.335 1.335 0 012.67 0v1.335H5.785A1.338 1.338 0 014.45 2.226M.89 5.786A1.338 1.338 0 012.225 4.45h3.56A1.337 1.337 0 017.12 5.786v1.335h-4.9A1.337 1.337 0 01.89 5.786m1.335 4.894a1.335 1.335 0 010-2.67H3.56v1.335a1.337 1.337 0 01-1.335 1.335m3.56 3.56a1.337 1.337 0 01-1.335-1.335v-3.56a1.337 1.337 0 011.335-1.334H7.12v4.894a1.336 1.336 0 01-1.335 1.335m4.894-1.335a1.335 1.335 0 11-2.67 0V11.57h1.336a1.336 1.336 0 011.335 1.335m2.22-2.225H9.345A1.336 1.336 0 018.01 9.345V8.011h4.89a1.335 1.335 0 110 2.67"}})])
          )
        }
      }
    